export const TRANSACTION_HISTORY_TYPES = {
  deposit: "Deposito",
  withdrawal: "Cobro",
};

export enum TransactionHistoryTypes {
  deposit = "Deposito",
  withdrawal = "Cobro",
}
